<template>
  <div class="settings">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    name: "Settings"
}
</script>

<style lang="scss">
.settings {
  .el-tabs__item {
    color: #999999 !important;
    /* color: #333333 !important; */
    font-weight: 500 !important;
    /* font-weight: 700 !important; */
    padding: 0 !important;
    margin-right: 30px !important;
  }
  .el-tabs__item.is-active {
    color: #333333 !important;
    /* color: #f9a168 !important; */
    font-weight: 700 !important;
    /* border-bottom: 2px solid #f9a168 !important; */
  }
  .el-tabs__active-bar {
    color: transparent !important;
    background-color: transparent !important;
  }
  .el-tabs__nav-wrap::after {
    background-color: transparent !important;
  }
  .el-tabs__header.is-top {
		/* background-color: #fff; */
		padding: 10px;
		margin-bottom: 0;
		margin-top: 15px;
		/* border-bottom: 1px solid #A3A4A64D; */
	}
	.el-card.mt-3.is-always-shadow {
		margin-top: 2px;
	}
  .br-12 {
    border-radius: 12px !important;
  }
  .capitalize {
    text-transform: capitalize;
  }
}
</style>
